/**
 * File: apps/qbench-cp/reactapp/src/shared/components/FormV2/Number.js
 *
 * Purpose: Renders the numeric input used by FormV2 for NUM field types.
 *
 * Scope: FormV2 input rendering for numeric entity fields.
 *
 * Tags: customer-portal
 *
 * Overview: Exports Number, a thin wrapper that renders the shared Input component with
 *     `type="number"` and `step="any"`, blurring the input on wheel events so scrolling the
 *     page does not inadvertently change the value. Reuses Input's transform strategy
 *     unchanged for server/client value conversion.
 *
 * Exports: default Number component (with an attached `transform` static property).
 */

import React from 'react';
import Input from './Input';

/**
 * @type {import('./types').FieldTransformStrategy}
 */
const transform = {
  fromServer: Input.transform.fromServer,
  toServer: Input.transform.toServer,
  defaultValue: Input.transform.defaultValue,
};

const Number = React.memo(function Number(props) {
  return (
    <Input type="number" step="any" onWheel={(e) => e.currentTarget.blur()} {...props} />
  );
});

Number.transform = transform;
export default Number;
